import paths from "../../api/paths.api";
import VendorMrqs from "../../pages/Vendor/Mrqs";
import VendorDocTransmittal from "../../pages/Vendor/VendorDocTransmittal";

export const vendorRoutes = [
  {
    path: paths.vendorMrqs,
    element: <VendorMrqs />,
  },
  {
    path: paths.vendorDocTransmittal,
    element: <VendorDocTransmittal />,
  },
  // {
  //   path: paths.vendorBidChat,
  //   element: <VendorBidChat />,
  // },
];
